import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';
import { ARIA_LABEL } from '@/constants/ariaLabel';
import { COMMON_STRING } from '@/constants/dictionary';
import {
  SUPERVISOR_EVALUATION,
  SUPERVISOR_EVALUATION_OPTIONS,
} from './constants';
import { EvaluationProps } from './SupervisorEvaluationComment';

export const SupervisorEvaluationSelect = ({
  evaluation,
  setEvaluation,
}: EvaluationProps) => {
  const onEvaluationSelect = (event: SelectChangeEvent) => {
    const selectedType = SUPERVISOR_EVALUATION_OPTIONS.find(
      (item) => event.target.value === item,
    );
    if (!selectedType) return;
    if (selectedType === SUPERVISOR_EVALUATION.POSITIVE) {
      setEvaluation({
        feedbackType: selectedType,
        feedbackText: COMMON_STRING.POSSITIVE_SUPERVISOR_FEEDBACK,
      });
    } else if (
      selectedType === SUPERVISOR_EVALUATION.NEGATIVE &&
      evaluation.feedbackText
    ) {
      setEvaluation({
        feedbackType: selectedType,
        feedbackText: '',
      });
    } else {
      setEvaluation({
        ...evaluation,
        feedbackType: selectedType,
      });
    }
  };

  return (
    <FormControl>
      <InputLabel
        id={ARIA_LABEL.SUPERVISOR_EVALUATION_SELECT_LABEL}
        size='small'
      >
        {COMMON_STRING.FEEDBACK_EVALUATION}
      </InputLabel>
      <Select
        data-testid={ARIA_LABEL.SUPERVISOR_EVALUATION_SELECT_LABEL}
        labelId={ARIA_LABEL.SUPERVISOR_EVALUATION_SELECT_LABEL}
        value={evaluation.feedbackType}
        onChange={onEvaluationSelect}
        size='small'
        label={COMMON_STRING.FEEDBACK_EVALUATION}
      >
        {SUPERVISOR_EVALUATION_OPTIONS.map((item) => (
          <MenuItem value={item} key={item}>
            {item}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
